const COUNTRY_FALLBACK_CODES = [
  'IT', 'DE', 'FR', 'ES', 'PT', 'CH', 'AT', 'BE', 'NL', 'LU', 'IE', 'GB', 'US', 'CA', 'MX', 'BR', 'AR', 'CL',
  'CO', 'PE', 'NO', 'SE', 'FI', 'DK', 'PL', 'CZ', 'SK', 'HU', 'RO', 'BG', 'GR', 'HR', 'SI', 'EE', 'LV', 'LT',
  'TR', 'UA', 'IL', 'AE', 'SA', 'IN', 'PK', 'CN', 'JP', 'KR', 'SG', 'AU', 'NZ', 'ZA',
] as const

const resolveCountryCodes = (): string[] => {
  const maybeIntl = Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] }
  if (typeof maybeIntl.supportedValuesOf === 'function') {
    try {
      const supported = maybeIntl.supportedValuesOf('region')
      if (Array.isArray(supported) && supported.length > 0) {
        return supported.filter((code) => /^[A-Z]{2}$/.test(code))
      }
    } catch {
      // `region` is not guaranteed in all runtimes: fallback list keeps the UX stable.
    }
  }
  return [...COUNTRY_FALLBACK_CODES]
}

export const buildCountryOptions = (locale: string) => {
  const regionNameResolver =
    typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames([locale], { type: 'region' }) : null

  return resolveCountryCodes()
    .map((code) => ({
      value: code,
      label: regionNameResolver?.of(code) ?? code,
    }))
    .sort((left, right) => left.label.localeCompare(right.label, locale))
}
